/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sdh_Text_Removal_HeadingInputs */



/**
* | output |
* | --- |
* | "Text removal" |
*
* @param {Sdh_Text_Removal_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sdh_text_removal_heading = /** @type {((inputs?: Sdh_Text_Removal_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sdh_Text_Removal_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Suppression de texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Textentfernung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimozione del testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удаление текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminación de texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本删除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट हटाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remoção de texto")
	return /** @type {LocalizedString} */ ("Text removal")
});